const PropTypes = require('prop-types');

module.exports = {
  children: PropTypes.node.isRequired
};
